import BaseService from "./_base-service";
import ax from '@shared/axios';

class GeneralTaskService extends BaseService {
   searchList(params: object) {
      return this.resource$.post<any>(`/wms-app/general-task/search-by-paging`, params);
   }

   updateList(params: object) {
      return this.resource$.post<any>(`/report-center/marketplace/item-batch-update`, params);
   }

   export() {
      return ax.post(`/wms-app/general-task/export`, {}, {
         responseType: 'arraybuffer'
      });
   }

   customerApproval(params: object) {
      return this.resource$.post<any>(`/wms-app/general-task/customerApproval`, params);
   }

   searchEmailMessage(taskId: string) {
      return this.resource$.get<any>(`/wms-app/general-task/searchEmailMessage/${taskId}`);
   }

   sendEmail(params: object) {
      return this.resource$.post<any>(`/bam/send-email`, params);
   }


}

let generalTaskService =  new GeneralTaskService();
export default generalTaskService;